export default __webpack_public_path__ + "static/media/logo-icon.f05d6255.png";